import { render, staticRenderFns } from "./SwipeCardStack.vue?vue&type=template&id=98b80580&scoped=true&"
import script from "./SwipeCardStack.vue?vue&type=script&lang=js&"
export * from "./SwipeCardStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b80580",
  null
  
)

export default component.exports